export default {"src":"/_next/static/media/lighting_icon.28f5a122.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};